// credentials utilities

interface GetMethodStringType {
  (param?: keyof BaseLinks): string;
}

interface BaseLinks {
  [key: string]: string;
}

const baseLinks: BaseLinks = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
  accessToken: process.env.REACT_APP_ACCESS_TOKEN || '',
  authorizeEndPoint: process.env.REACT_APP_AUTHORIZED_ENDPOINT || '',
  clientId: process.env.REACT_APP_CLIENT_ID || '', //unused, to be removed after login route
};

export const getCartoString: GetMethodStringType = (value = 'apiBaseUrl') =>
  baseLinks[value];
